
export const dateToLocalString = (date) => {
  if (!date) return "";
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
};

export const stringToDate = (dateStr) => {
  if (!dateStr) return null;
  const [year, month, day] = dateStr.split("-").map(Number);
  return new Date(year, month - 1, day);
};

export const formatDisplayDate = (dateStr) => {
  if (!dateStr) return "";
  // Ensure we create a date object from the string correctly
  const date = stringToDate(dateStr); 
  return date.toLocaleDateString("en-US", { 
    weekday: "short", 
    month: "short", 
    day: "numeric" 
  });
};

export const isBefore = (dateA, dateB) => {
  if (!dateA || !dateB) return false;
  
  const d1 = typeof dateA === "string" ? stringToDate(dateA) : dateA;
  const d2 = typeof dateB === "string" ? stringToDate(dateB) : dateB;
  
  // Set both to midnight to compare only the calendar date
  d1.setHours(0, 0, 0, 0);
  d2.setHours(0, 0, 0, 0);
  
  return d1.getTime() < d2.getTime();
};